<template>
    <v-row style="border-bottom:1px dotted #fafafa">
        <v-col cols="2">{{exercise.name}}</v-col> 
        <v-col cols="9">
            <v-row v-for="(set, index) in exercise.sets" :key="index">
                <v-col>
                   <v-subheader>Set {{index + 1}}</v-subheader>
                </v-col>
                <v-col>
                    <v-text-field small type="number" v-model="set.reps" required label="Target Reps"></v-text-field>
                </v-col>
                <v-col>
                     <v-btn v-if="exercise.sets.length > 1" color="primary" elevation="0" small icon @click="removeSet(index)">
                       <v-icon>mdi-delete</v-icon>
                    </v-btn>
                </v-col> 
            </v-row>
            <v-row>
                <v-col>
                    <v-btn color="primary"  small text @click="addSet">
                        <v-icon>mdi-plus</v-icon> Add New Set
                    </v-btn>
                </v-col>
            </v-row>
        </v-col> 
        <v-col cols="1">
            <v-btn color="default" small icon @click="removeExercise"> 
                <v-icon>mdi-delete</v-icon>
            </v-btn>
        </v-col> 
    </v-row>
</template>

<script>


export default {
    props:{
        exercise: Object
    },
    data(){
        return {
            //Exercise: this.exercise
        }
    },
    methods:{

        addSet(){

            let ceca = {reps: null};
            this.exercise.sets.push(ceca);
        },

        removeSet(index){
            this.exercise.sets.splice(index, 1);
        },
        removeExercise(){

        }
    }

}
</script>
